import { render, staticRenderFns } from "./pageMagicSquareModule.vue?vue&type=template&id=797923a8&scoped=true"
import script from "./pageMagicSquareModule.vue?vue&type=script&lang=js"
export * from "./pageMagicSquareModule.vue?vue&type=script&lang=js"
import style0 from "./pageMagicSquareModule.vue?vue&type=style&index=0&id=797923a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797923a8",
  null
  
)

export default component.exports